/**
 * Dashboard Plugin System - Main Entry Point
 * 
 * Reactive registry for frontend plugin extensions in Chatwoot.
 * 
 * Naming Convention:
 * - dashboard-* : Frontend/UI related code (Vue components, i18n, etc.)
 * - api-*       : Backend/API related code (Rails controllers, models, etc.)
 */

import { PluginSystem } from './dashboard-api';
import { log } from './dashboard-utils';

// Export types for plugins to use
export type {
  TabConfig,
  ComponentConfig,
  ProviderConfig,
  ChannelTypeMapping,
  PluginSystemAPI,
} from './dashboard-types';

// ============================================================================
// Global Namespace Setup
// ============================================================================

if (typeof window !== 'undefined') {
  // Criar namespace principal unificado
  window.chatwoot = window.chatwoot || {};
  window.chatwoot.config = window.chatwoot.config || (window.chatwootConfig || {});
  window.chatwoot.plugins = window.chatwoot.plugins || {};

  // Manter compatibilidade retroativa
  window.chatwootConfig = window.chatwoot.config;
  window.chatwootPlugins = window.chatwoot.plugins;

  // Legacy interface for whatsappProviders (se não existir)
  if (!Object.getOwnPropertyDescriptor(window.chatwoot.plugins, 'whatsappProviders')) {
    Object.defineProperty(window.chatwoot.plugins, 'whatsappProviders', {
      get() {
        return PluginSystem.getProviders('whatsapp');
      },
      configurable: true,
      enumerable: true
    });
  }
  
  // Compatibilidade: window.chatwootPlugins.whatsappProviders
  if (!Object.getOwnPropertyDescriptor(window.chatwootPlugins, 'whatsappProviders')) {
    Object.defineProperty(window.chatwootPlugins, 'whatsappProviders', {
      get() {
        return PluginSystem.getProviders('whatsapp');
      },
      configurable: true,
      enumerable: true
    });
  }

  // Expose PluginSystem globally
  window.PluginSystem = PluginSystem;
  window.chatwoot.PluginSystem = PluginSystem;

  log('✅ Plugin System initialized');
  log('📦 Global namespace: window.chatwoot { config, plugins, PluginSystem, channelRegistry }');
}

export { PluginSystem };
export default PluginSystem;
